let profileState = {
    data: [],
    isLoading: false,
    error: "",
    gstStatus: "",
    tanStatus: "",
    panStatus: "",
    isVerifiedSeller: true,
    sellerAddress: [],
    isaddressTabLoading: false,
    msg: {
        text: "",
        type: ""
    },
    isProfileOk: true
}

const profileReducer = (state = profileState, action) => {
    switch (action.type) {


        case "FETCH_PROFILE":
            return {
                ...state, isLoading: true, error: ""
            }
        case "FETCH_PROFILE_SUCCESS":
            let payload = action.payload.data;
            let gstSt = ""
            let tanSt = ""
            let panSt = ""
            if (payload.panVerified && payload.panVerified.status) {
                panSt = payload.panVerified.status
            }
            if (payload.tanVerified && payload.tanVerified.status) {
                tanSt = payload.tanVerified.status
            }
            if (payload.gstVerified && payload.gstVerified.status) {
                gstSt = payload.gstVerified.status
            }
            return {
                ...state,
                data: action.payload.data,
                isLoading: false,
                gstStatus: gstSt,
                panStatus: panSt,
                tanStatus: tanSt,
                isVerifiedSeller: action.payload.msg === "seller fetched" ? true : false
            }
        case "FETCH_PROFILE_ERROR":
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }

        case "UPDATE_PROFILE_PIC":
            return {
                ...state, error: ""
            }
        case "UPDATE_PROFILE_PIC_SUCCESS":
            return {
                ...state,
                data: { ...state.data, avatar: action.payload },
                msg: {
                    ...state.msg, text: "Profile picture updated successfully", type: "success"
                }
            }
        case "UPDATE_PROFILE_PIC_ERROR":
            return {
                ...state, error: action.payload
            }


        case "FETCH_SELLER_ADDRESS":
            return {
                ...state, isaddressTabLoading: true, error: ""
            }
        case "FETCH_SELLER_ADDRESS_SUCCESS":

            return {
                ...state,
                sellerAddress: action.payload,
                isaddressTabLoading: false
            }
        case "FETCH_SELLER_ADDRESS_ERROR":
            return {
                ...state,
                error: action.payload,
                isaddressTabLoading: false
            }

        case "DELETE_SELLER_ADDRESS_SUCCESS":
            state.sellerAddress.splice(action.payload, 1)
            return {
                ...state, msg: {
                    ...state.msg, text: "Address deleted successfully", type: "success"
                }
            }
        case "DELETE_SELLER_ADDRESS_ERROR":
            return {
                ...state, msg: {
                    ...state.msg, text: "Address deleted successfully", type: "success"
                }
            }

        // Sl-828
        case "UPDATE_SELLER_PROFILE_OK_STATUS":
            return {
                ...state,
                isProfileOk: action?.payload
            }
        default:
            return state
    }
}
export default profileReducer